import axios from '../../../shared/utils/axios-init';

const initialState = {
  loginState: false,
  isAuthenticated: false,
  verificationStatus: null,
  loginDialog: false,
  registrationDialog: false,
  userId: null,
  userName: null,
  twoStepsAuthActive: false,
};

const getters = {
  getLoginData(state) {
    return state.loginData;
  },
  isAuthenticated: (state) => state.isAuthenticated,
  isVerified: (state) => Number(state.verificationStatus) === 1,
  loginDialogState(state) {
    return state.loginDialog;
  },
  regDialogState(state) {
    return state.registrationDialog;
  },
  getUserName: (state) => state.userName,
  getUserId: (state) => state.userId,
};

const mutations = {
  setAuthenticated(state, data) {
    state.isAuthenticated = data;
  },
  setVerificationStatus(state, data) {
    state.verificationStatus = data;
  },
  setUserId(state, id) {
    state.userId = id;
  },
  setUserName(state, data) {
    state.userName = data;
  },
  setTwoStepsAuthActive(state, data) {
    const boolValue = Boolean(Number(data));
    state.twoStepsAuthActive = boolValue;
  },
  toggleLoginDialog(state, data) {
    state.loginDialog = data;
  },
  toggleRegDialog(state, data) {
    state.registrationDialog = data;
  },
};

const actions = {
  async login({ commit, dispatch }, credentials) {
    try {
      const data = await axios.post('/user/auth', JSON.stringify(credentials));

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async register({ commit, dispatch }, credentials) {
    try {
      const data = await axios.post(
        '/user/register',
        JSON.stringify(credentials)
      );

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async activate({ commit }, activation) {
    try {
      const data = await axios.post(
        '/user/activate',
        JSON.stringify(activation)
      );

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async resendActivation({ commit }, activation) {
    try {
      const data = await axios.post(
        '/user/resend-activation',
        JSON.stringify(activation)
      );

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async forgotPassword({ commit, dispatch }, forgotData) {
    try {
      const data = await axios.post('/user/forgot', JSON.stringify(forgotData));

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async restorePassword({ commit, dispatch }, forgotData) {
    try {
      const data = await axios.post(
        '/user/restore',
        JSON.stringify(forgotData)
      );

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async checkUnique({ commit, dispatch }, checkData) {
    try {
      const data = await axios.post('/unique', JSON.stringify(checkData));

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async checkUser({ commit, dispatch }) {
    try {
      let data;
      const token =
        localStorage.getItem('token') || sessionStorage.getItem('token');

      if (token) {
        data = await axios.get('/user', {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        data = await axios.get('/user');
      }

      if (data.data.success) {
        commit('setAuthenticated', true);
        commit('setVerificationStatus', data.data.userData.doc_confirmed);
        commit('setUserId', data.data.userData.id);
        commit('setUserName', data.data.userData.name);
        commit('setTwoStepsAuthActive', data.data.userData.two_steps_auth);
        commit(
          'account/verification/setStatusCode',
          data.data.userData.doc_confirmed,
          { root: true }
        );
      } else {
        commit('setAuthenticated', false);
        commit('setUserId', null);
        commit('setUserName', null);
        dispatch('dashboard/finance/fetchFinanceData', null, { root: true });
        commit('dashboard/requests/setRequestsData', [], { root: true });
      }
      return data;
    } catch (error) {
      /* eslint-disable */
      return error;
    }
  },
  logOut({ commit, dispatch }) {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    commit('setAuthenticated', false);
    commit('setUserId', null);
    commit('setUserName', null);
    commit('setTwoStepsAuthActive', false);
    dispatch('dashboard/finance/fetchFinanceData', null, { root: true });
    commit('dashboard/requests/setRequestsData', [], { root: true });
  },
  async checkCode({ commit, dispatch }, credentials) {
    try {
      const data = await axios.post(
        '/user/check-code',
        JSON.stringify(credentials)
      );

      return data;
    } catch (error) {
      return error.response;
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Auth/modules/auth.js